// A reply in progress outlives its tab: the send can fail, and the text is the
// only part of it nobody can reconstruct afterwards.
const KEY = 'outreach.replyDrafts';

const all = () => {
  const stored = window.localStorage.getItem(KEY);
  return stored === null ? {} : JSON.parse(stored);
};

export const loadReplyDraft = (threadId) => {
  const draft = all()[threadId];
  return draft === undefined ? '' : draft;
};

export const saveReplyDraft = (threadId, text) => {
  const drafts = all();
  if (text.trim()) {
    drafts[threadId] = text;
  } else {
    delete drafts[threadId];
  }
  window.localStorage.setItem(KEY, JSON.stringify(drafts));
};

export const clearReplyDraft = (threadId) => saveReplyDraft(threadId, '');
